<ng-container *transloco="let t">
  @if (communicationPreferencesStore.isLoading()) {
    <ns-spinner size="lg" [message]="t('accountDetails.communicationPreferences.loading')" />
  } @else if (communicationPreferencesStore.loadError()) {
    @if (loadingErrorSource() === 'onboarding') {
      <ns-error-card [heading]="t('onboarding.steps.communicationPreferences.loadingError.header')" image="error" centered intent="error">
        {{ t('onboarding.steps.communicationPreferences.loadingError.message') }}
      </ns-error-card>
    } @else {
      <ns-error-card [heading]="t('core.loadingError.header')" image="error" centered intent="error">
        {{ t('core.loadingError.message') }}
      </ns-error-card>
    }
  } @else {
    <sds-banner icon="sdsInfo" intent="information" [title]="t('accountDetails.communicationPreferences.deliveryEmailTitle')">
      {{ email() }}
    </sds-banner>

    <div class="communication-preferences__aggregate">
      <sds-switch
        [label]="t('accountDetails.communicationPreferences.aggregateLabel')"
        aria-describedby="communication-preferences-aggregate-description"
        [checked]="allDraftPreferencesEnabled()"
        [disabled]="communicationPreferencesStore.isSaving()"
        (checkedChange)="updateAll($event)"
      />
      <p class="communication-preferences__aggregate-description" id="communication-preferences-aggregate-description">
        {{ t('accountDetails.communicationPreferences.aggregateDescription') }}
      </p>
    </div>

    <ul class="communication-preferences__list" [class.communication-preferences__list--columns-two]="columns() === 'two'">
      @for (preference of draftPreferences(); track preference.id) {
        <li class="communication-preferences__item">
          <div class="communication-preferences__item-content">
            <h3 class="communication-preferences__item-title" [id]="'communication-preference-' + preference.id + '-name'">
              {{ t('accountDetails.communicationPreferences.items.' + preference.id + '.name') }}
            </h3>
            <p class="communication-preferences__item-description" [id]="'communication-preference-' + preference.id + '-description'">
              {{ t('accountDetails.communicationPreferences.items.' + preference.id + '.description') }}
            </p>
          </div>
          <sds-switch
            [label]="t('accountDetails.communicationPreferences.items.' + preference.id + '.name')"
            [attr.aria-labelledby]="'communication-preference-' + preference.id + '-name'"
            [attr.aria-describedby]="'communication-preference-' + preference.id + '-description'"
            [checked]="preference.enabled"
            [disabled]="communicationPreferencesStore.isSaving()"
            (checkedChange)="updatePreference(preference.id, $event)"
          />
        </li>
      }
    </ul>

    <div class="communication-preferences__actions">
      <ng-content />
    </div>

    <p class="sr-only" role="status" aria-live="polite" aria-atomic="true">
      @if (communicationPreferencesStore.isSaving()) {
        {{ t('accountDetails.communicationPreferences.saving') }}
      }
    </p>
  }
</ng-container>
